document.addEventListener('algolia.hooks.initialize', function() {

  algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function(options) {
    /*Change the placeholder text of the autocomplete menu*/
    options.placeholder = "What are you looking for?";
    options.distinct = true;
    return options;
  });
  /* Autocomplete: Newest Items first */
  algoliaShopify.hooks.registerHook(
    'beforeAutocompleteConfigurationOptions',
    function(options) {
      options.indexName =
        'shopify_online_lightingproducts_published_at_desc';

      return options;
    }
  );
  /* Restrict Duplicate product variant */
  algoliaShopify.hooks.registerHook(
    'beforeAutocompleteProductTransformResponseHits',
    function (hits) {
      const products = new Map();
     

      hits.forEach((hit) => {
        const key = hit.id;

        if (!products.has(key)) {
          products.set(key, hit);
          return;
        }

        // Prefer the default variant
        if (hit.variant_title === 'Default Title') {
          products.set(key, hit);
        }
      });

      return [...products.values()];
    }
  );
  algoliaShopify.hooks.registerHook(
  'beforeAutocompleteProductTemplate',
  function (_defaultTemplate, templateOptions, distinct, itemLink, trackSearchAttribution) {
    const { html, item, components } = templateOptions;
    const variantId = new URL(itemLink, window.location.origin).searchParams.get("variant") || item.objectID;

    // 1. Image logic
    let imageUrl = item.image;
    let srcset = item.srcset || '';
    
    try {
      imageUrl = imageUrl.replace('_125x', '_256x');
      srcset = srcset
        .replace('_125x', '_256x')
        .replace('_250x', '_400x')
        .replace('_375x', '_600x');
    } catch (e) {
      console.log("Image modification failed", e);
    }

    // ✅ 2. Get custom price
    const priceData = getPriceSync(item);

    // ✅ 3. Fallback if rates not loaded yet
    const finalPrice = window.exchangeRates
      ? priceData.price
      : algoliaShopify.helpers.displayPrice(item);
      //  console.log("hits", hit);

    return html`
      <a href="${itemLink}"
        class="aa-ItemLink aa-ProductItem"
        data-live-handle="${item.handle}"
        data-live-variant-id="${variantId}"
        onClick="${() => trackSearchAttribution(item)}">
        <div class="aa-ItemContent">

          <div class="aa-ItemPicture aa-ItemPicture--loaded">
            <img 
              src="${imageUrl}" 
              srcset="${srcset}" 
              sizes="(max-width: 256px) 100vw, 256px" 
              alt="${item.title}" 
            />
          </div>

          <div class="aa-ItemContentBody">

            <div class="aa-ItemContentTitleWrapper">
              <div class="aa-ItemContentTitle">
                ${components.Highlight({ hit: item, attribute: 'title' })}
                <span class="algolia-variant"></span>
              </div>
            </div>

            <!-- SKU -->
            <div class="aa-ItemContentDescription aa-ItemSKU" style="font-size: 0.8em; color: #666;">
              SKU: ${components.Highlight({ hit: item, attribute: 'sku' })}
            </div>

            <!-- ✅ CUSTOM PRICE -->
            <div class="aa-ItemContentPrice">
              <div class="aa-ItemContentPriceCurrent">
                ${finalPrice}
              </div>

              ${
                window.exchangeRates && priceData.compare
                  ? html`
                      <div class="aa-ItemContentPriceCompare" style="text-decoration: line-through; color:#999; font-size:0.85em;">
                        ${priceData.compare}
                      </div>
                    `
                  : ''
              }
            </div>

          </div>
        </div>
      </a>
    `;
  }
);



  // algoliaShopify.hooks.registerHook(
  //   'beforeAutocompleteProductTemplate',
  //   function (_defaultTemplate, templateOptions, distinct, itemLink, trackSearchAttribution) {
  //     const { html, item, components } = templateOptions;

  //     // 1. Apply your custom image logic to the item object
  //     let imageUrl = item.image;
  //     let srcset = item.srcset || '';
      
  //     try {
  //       // Logic to increase image size
  //       imageUrl = imageUrl.replace('_125x', '_256x');
  //       srcset = srcset
  //         .replace('_125x', '_256x')
  //         .replace('_250x', '_400x')
  //         .replace('_375x', '_600x');
  //     } catch (e) {
  //       console.log("Image modification failed", e);
  //     }
      

  //     // 2. Return the new template including the SKU
  //     return html`
  //       <a href="${itemLink}" class="aa-ItemLink aa-ProductItem" onClick="${() => trackSearchAttribution(item)}">
  //         <div class="aa-ItemContent">
  //           <div class="aa-ItemPicture aa-ItemPicture--loaded">
  //             <img 
  //               src="${imageUrl}" 
  //               srcset="${srcset}" 
  //               sizes="(max-width: 256px) 100vw, 256px" 
  //               alt="${item.title}" 
  //             />
  //           </div>
  //           <div class="aa-ItemContentBody">
  //             <div class="aa-ItemContentTitleWrapper">
  //                 <div class="aa-ItemContentTitle">${components.Highlight({ hit: item, attribute: 'title' })} <span class="algolia-variant"></span>
  //                 </div>
  //               </div>
  //             <!-- Added SKU display below the title -->
  //             <div class="aa-ItemContentDescription aa-ItemSKU" style="font-size: 0.8em; color: #666;">
  //               SKU: ${components.Highlight({ hit: item, attribute: 'sku' })}
  //             </div>
  //             <div class="aa-ItemContentPrice">
  //               <div class="aa-ItemContentPriceCurrent">${algoliaShopify.helpers.displayPrice(item)}</div>
  //             </div>
  //           </div>
  //         </div>
  //       </a>
  //     `;
  //   }
  // );

  const WRAPPER_SELECTOR = '.ais-facet-dropdown-wrapper';
  const PRICE_CLASS = 'ais-facet-price';
  const STYLE_ID = 'aa-collapse-facets-css';

  /* -----------------------------
   * Inject collapse CSS once
   * ----------------------------- */
  if (!document.getElementById(STYLE_ID)) {
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .aa-facet-collapsed .ais-facet-dropdown-container {
        display: none !important;
      }
      .ais-facet-dropdown-wrapper:not(.aa-facet-collapsed) .ais-facet-dropdown-container {
        display: block !important;
      }
      .ais-facet-dropdown-wrapper > label {
        cursor: pointer;
      }
      
      .ais-page .ais-Hits .addtocart-price-section.no-price-element {
        display: flex;
        align-items: center;
        width: 100%;
        justify-content: end;
      }

      .ais-page .ais-Hits .addtocart-price-section.no-price-element .ais-hit--product-link {
        margin-left: auto;
        flex-shrink: 0;
      }

    `;
    document.head.appendChild(style);
  }

  /* -----------------------------
   * Detect active refinement (ROBUST)
   * ----------------------------- */
  function hasSelectedRefinement(wrapper) {
    return (
      wrapper.querySelector('[aria-current="true"]') ||          // current refinements
      wrapper.querySelector('.ais-RefinementList-item--selected') ||
      wrapper.querySelector('input[type="checkbox"]:checked') ||
      wrapper.querySelector('.ais-RangeSlider .ais-RangeSlider-handle') ||
      wrapper.querySelector('.ais-RangeInput-input[value]:not([value=""])')
    );
  }

  /* -----------------------------
   * Init facet (events only)
   * ----------------------------- */
  function initFacet(wrapper) {
    if (wrapper.dataset.aaFacetInit === '1') return;
    wrapper.dataset.aaFacetInit = '1';

    const label = wrapper.querySelector('label');
    if (!label) return;

    label.addEventListener('click', (e) => {
      e.preventDefault();
      wrapper.classList.toggle('aa-facet-collapsed');
      label.setAttribute(
        'aria-expanded',
        String(!wrapper.classList.contains('aa-facet-collapsed'))
      );
    });
  }

  /* -----------------------------
   * Apply open / close state (EVERY render)
   * ----------------------------- */
  function applyFacetState(wrapper) {
    const isPrice = wrapper.classList.contains(PRICE_CLASS);
    const hasSelection = hasSelectedRefinement(wrapper);

    let shouldCollapse;

    if (hasSelection) {
      shouldCollapse = false;     // always open if selected
    } else if (isPrice) {
      shouldCollapse = false;     // price default open
    } else {
      shouldCollapse = true;      // others closed
    }

    wrapper.classList.toggle('aa-facet-collapsed', shouldCollapse);

    const label = wrapper.querySelector('label');
    if (label) {
      label.setAttribute('aria-expanded', String(!shouldCollapse));
    }
  }

  /* -----------------------------
   * Sort ALL facet values A → Z
   * (Price facet skip, kyunki wahan numeric order chahiye)
   * ----------------------------- */
  function sortFacetValues() {
    document.querySelectorAll('.ais-facet-dropdown-container').forEach(container => {
      const wrapper = container.closest(WRAPPER_SELECTOR);
      if (wrapper && wrapper.classList.contains(PRICE_CLASS)) return;

      container.querySelectorAll('ul').forEach(list => {
        const items = Array.from(list.children).filter(el => el.tagName === 'LI');
        if (items.length < 2) return;

        const getName = (li) => {
          const clone = li.cloneNode(true);
          clone.querySelectorAll('[class*="count"]').forEach(c => c.remove());
          return clone.textContent.replace(/\s+/g, ' ').trim();
        };

        const sorted = items
          .map(li => ({ li, name: getName(li) }))
          .sort((a, b) =>
            a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' })
          );

        // Already sorted hai to DOM touch mat karo
        if (sorted.every((o, i) => o.li === items[i])) return;

        sorted.forEach(o => list.appendChild(o.li));
      });
    });
  }

  /* -----------------------------
   * Toggle "no-product" class on .ais-block
   * when search returns zero results.
   *
   * Uses a MutationObserver on the hits container
   * because Algolia renders hits asynchronously,
   * so checking right on 'algolia.instantSearch.onRender'
   * can run before the hits are actually painted.
   * ----------------------------- */
  function evaluateNoResultState() {
    const aisBlock = document.querySelector('.ais-block');
    const hitsContainer = document.querySelector('.ais-hits-container');

    if (!aisBlock || !hitsContainer) return;

    const hasHits =
      hitsContainer.querySelectorAll('.ais-hit, .ais-InfiniteHits-item').length > 0;

    aisBlock.classList.toggle('no-product', !hasHits);
  }

  function initNoResultObserver() {
    const hitsContainer = document.querySelector('.ais-hits-container');
    if (!hitsContainer) return;

    if (hitsContainer.dataset.aaNoResultObserverInit === '1') {
      // Already observing this container, just re-check current state.
      evaluateNoResultState();
      return;
    }

    hitsContainer.dataset.aaNoResultObserverInit = '1';

    const observer = new MutationObserver(() => {
      evaluateNoResultState();
    });

    observer.observe(hitsContainer, { childList: true, subtree: true });

    evaluateNoResultState();
  }

  let newestSortInitialized = false;

  function reorderCollectionSort() {
    const select = document.querySelector('.ais-SortBy-select');

    if (!select) return;

    const newest = Array.from(select.options).find(
      option =>
        option.value ===
        'shopify_online_lightingproducts_published_at_desc'
    );

    const relevance = Array.from(select.options).find(
      option =>
        option.value ===
        'shopify_online_lightingproducts'
    );

    if (!newest || !relevance) return;

    // Always maintain the desired option order
    newest.remove();
    relevance.remove();

    select.prepend(relevance);
    select.prepend(newest);

    // Set Newest only once
    if (!newestSortInitialized) {
      newestSortInitialized = true;

      select.value = newest.value;

      select.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );
    }
  }

  /* -----------------------------
   * InstantSearch render
   * ----------------------------- */
  document.addEventListener('algolia.instantSearch.onRender', () => {
    document.querySelectorAll(WRAPPER_SELECTOR).forEach(wrapper => {
      initFacet(wrapper);        // bind once
      applyFacetState(wrapper);  // re-evaluate ALWAYS
    });
    sortFacetValues();           // ✅ NEW: all filters A → Z
    formatprice();
    initNoResultObserver();
    reorderCollectionSort();
  });

  function formatprice() {

    // Fix Current Refinements Price Range display
    document.querySelectorAll(
      '.ais-current-refined-values--link[data-attribute="price_range"]'
    ).forEach((link) => {

         const rawValue = decodeURIComponent(
          link.getAttribute('data-value') || ''
        );

        if (!rawValue.includes(':')) return;

        const [min, max] = rawValue.split(':');

        const currency =
      window.Shopify?.currency?.active || 'AUD';

    const rates = window.exchangeRates || {};
    const rate = rates[currency] || 1;

    let minValue = Number(min);
    let maxValue = Number(max);

    // Convert from AUD to active currency
    if (currency !== 'AUD' && rate) {
      minValue *= rate;
      maxValue *= rate;
    }

    const formatter = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency
    });

    const wrapper = link.querySelector('div');

    if (!wrapper) return;

    wrapper.innerHTML = `
      <div class="ais-current-refined-values--label">
        Price range: 
      </div>
       ${formatter.format(minValue)} - ${formatter.format(maxValue)}
    `;

    

    });

    document.querySelectorAll(
  '.ais-current-refined-values--link[data-attribute="price"]'
).forEach((link) => {

  const value = Number(link.dataset.value);

  if (isNaN(value)) return;

  const currency =
    window.Shopify?.currency?.active || 'AUD';

  const rates = window.exchangeRates || {};
  const rate = rates[currency] || 1;

  const convertedValue =
    currency === 'AUD'
      ? value
      : value * rate;

  const formatter = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency
  });

  const operator = decodeURIComponent(
    link.dataset.operator || ''
  );

  let displayValue = formatter.format(convertedValue);

  if (operator === '>=') {
    displayValue = `≥ ${displayValue}`;
  } else if (operator === '<=') {
    displayValue = `≤ ${displayValue}`;
  }

  const wrapper = link.querySelector('div');

  if (!wrapper) return;

  wrapper.innerHTML = `
    <div class="ais-current-refined-values--label">
      Price: 
    </div>
     ${displayValue}
  `;
});

    // Other facets (Colour Temperature, Brands, Type, etc.):
    // colon label ke saath, value ke aage wala default ":" hata do
    document.querySelectorAll('.ais-current-refined-values--link').forEach((link) => {
      const label = link.querySelector('.ais-current-refined-values--label');
      if (!label) return;

      const text = label.textContent.trim();
      if (text && !text.endsWith(':')) {
        label.textContent = text + ': ';
      }

      label.parentNode.childNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE && /^\s*:/.test(node.textContent)) {
          node.textContent = node.textContent.replace(/^\s*:\s*/, ' ');
        }
      });

      // Hover pe title tooltip
      link.setAttribute(
        'title',
        'Remove ' + link.textContent.replace(/\s+/g, ' ').trim()
      );
    });

  }

window.exchangeRates = null;

const initRates = async () => {
  const res = await fetch("https://open.er-api.com/v6/latest/AUD");
  const data = await res.json();
  window.exchangeRates = data?.rates || {};
};

// IMPORTANT: wait before Algolia loads
initRates();


const shopifyPriceCache = new Map();
const shopifyPricePending = new Map();
const SHOPIFY_PRICE_CACHE_MS = 30000;

async function getShopifyPriceSync(hit) {
  const currency = window.Shopify?.currency?.active || "AUD";
  const handle = hit.handle;
  const variantId = hit.objectID;

  if (!handle || !variantId) {
    throw new Error("Missing Shopify handle or variant ID");
  }

  const key = `${handle}:${variantId}:${currency}`;
  const cached = shopifyPriceCache.get(key);

  if (cached && Date.now() - cached.time < SHOPIFY_PRICE_CACHE_MS) {
    return cached.data;
  }

  if (shopifyPricePending.has(key)) {
    return shopifyPricePending.get(key);
  }

  const request = (async () => {
    const root = window.Shopify?.routes?.root || "/";
    const response = await fetch(
      `${root}products/${encodeURIComponent(handle)}.js`
    );

    if (!response.ok) {
      throw new Error(`Shopify request failed: ${response.status}`);
    }

    const product = await response.json();

    const variant = product.variants.find(
      item => String(item.id) === String(variantId)
    );

    if (!variant) {
      throw new Error(`Variant ${variantId} not found`);
    }

    const data = {
      price: Number(variant.price) / 100,
      compare:
        variant.compare_at_price != null
          ? Number(variant.compare_at_price) / 100
          : null,
      currency
    };

    shopifyPriceCache.set(key, {
      data,
      time: Date.now()
    });

    return data;
  })();

  shopifyPricePending.set(key, request);

  try {
    return await request;
  } finally {
    shopifyPricePending.delete(key);
  }
}

const BASE_CURRENCY = "AUD";

const getPriceSync = (hit) => {
  const currency = window.Shopify?.currency?.active || "AUD";
  const rates = window.exchangeRates || {};

  let price = hit.price;
  let compare = hit.compare_at_price;

  // ✅ 1. Shopify presentment_prices (priority)
  if (hit.presentment_prices?.length) {
    const presentment = hit.presentment_prices.find(
      (p) => p.currency_code === currency
    );

    if (presentment) {
      price = presentment.price ?? price;
      compare = presentment.compare_at_price ?? compare;
    } else {
      const rate = rates[currency];
      if (currency !== BASE_CURRENCY && rate) {
        price = price * rate;
        if (compare) compare = compare * rate;
      }
    }
  } else {
    // ✅ 2. fallback to FX API
    const rate = rates[currency];
    if (currency !== BASE_CURRENCY && rate) {
      price = price * rate;
      if (compare) compare = compare * rate;
    }
  }

  const format = (value) =>
    new Intl.NumberFormat(undefined, {
      style: "currency",
      currency,
    }).format(value);

  return {
    price: format(price),
    compare: compare ? format(compare) : null,
  };
};

  algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function(_defaultTemplate, hit, html, components) {
    // console.log("hit", hit);

//       const now = Date.now();        
//      const availableDate = hit?.meta?.custom?.avail_since
//   ? Number(hit.meta.custom.avail_since)
//   : null;

// const isPickupOnly = hit?.meta?.custom?.pickup_only_text === "true";

// // Show Coming Soon when the availability date is in the future
// // and inventory is unavailable.
// const isComingSoon =
//   availableDate !== null &&
//   !Number.isNaN(availableDate) &&
//   availableDate > Date.now() &&
//   hit.inventory_available === false;

// console.log("availableDate:", availableDate);
// console.log("current timestamp:", Date.now());
// console.log("isComingSoon:", isComingSoon);

// const commingsoon = isComingSoon || isPickupOnly ? "true" : "false";
// const isOfferBanner = false;

const now = Date.now();

const rawAvailSince = hit?.meta?.custom?.avail_since;
const parsed = rawAvailSince ? new Date(rawAvailSince).getTime() : NaN;
const availableDate = Number.isNaN(parsed) ? null : parsed;

const isPickupOnly = hit?.meta?.custom?.pickup_only_text === "true";

// Coming Soon whenever the availability date is in the future
const isComingSoon = availableDate !== null && availableDate > now;

const commingsoon = isComingSoon || isPickupOnly ? "true" : "false";
const isOfferBanner = true;

      window.openQuickView = async function(hit) {
        const dialog = document.querySelector("#quick-add-dialog dialog");
        const content = document.querySelector("#quick-add-modal-content");
        if (!dialog || !content) return;

        dialog.showModal();
        content.innerHTML = '';

        try {
          // Direct URL with our new template
          const url = `/products/${hit.handle}?view=quick-view`;

          const res = await fetch(url);
          const html = await res.text();

          // Parse only the inner div
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const quickViewContent = doc.querySelector('#QuickViewContent');

          content.innerHTML = quickViewContent? quickViewContent.innerHTML: '<p>Failed to load product</p>';

        } catch (err) {
          content.innerHTML = `<p>Failed to load product</p>`;
          console.error(err);
        }
      };


  
    /*const isSoldOut = hit.inventory_available === false;*/
    // const isSoldOut = false;
    const isSoldOut = hit.inventory_available === false;
    /*console.log(hit);
    console.log("-=-=-=-=-");
    console.log(hit.inventory_available);
    console.log(hit);*/
    const isSale =
      hit.compare_at_price &&
      hit.price &&
      hit.compare_at_price > hit.price;

    let badgeText = null;
    let badgeClass = '';
    let hitCanOrder = true;

    // if (isSoldOut && hit.can_order == false) {
    //   badgeText = 'Sold out';
    //   badgeClass = 'sold-out';
    //   hitCanOrder = hit.can_order;
    // } 
//     if (isSoldOut) {
//   badgeText = 'Sold out';
//   badgeClass = 'sold-out';
//   hitCanOrder = false;
// } 
     if (isSale) {
      badgeText = 'Sale';
      badgeClass = 'sale';
    }
    /*console.log(hitCanOrder);
    console.log(hit?.variants_count);*/
    
    return html`
      <div
        class="ais-hit ais-product"
        data-algolia-index="${hit.index}"
        data-algolia-position="${hit.productPosition}"
        data-algolia-queryid="${hit.queryID}"
        data-algolia-objectid="${hit.objectID}"
        data-handle="${hit.handle}"
        data-distinct="${hit._distinct}"
        data-product-id="${hit.id}"
        onClick="${() => algoliaShopify.helpers.handleItemClick(hit)}"
      >
      ${badgeText && html`
        <div class="product-badges product-badges--top-right">
          <div class="product-badges__badge product-badges__badge--rectangle color-scheme-1">
            <div class="${badgeClass}">${badgeText}</div>
          </div>
        </div>
      `}

       <div class="img-container">
          <a
            class="ais-hit--picture-link"
            href="/products/${hit.handle}${
              localStorage.getItem('shopbybrand') ? '?shopbybrand' : ''
            }"
            aria-label="${hit.title}"
            tabindex="-1"
            style="display:block;"
          >
            <img
              class="ais-hit--picture"
              src="${algoliaShopify.helpers.largeImage(hit)}"
              alt="${hit.title} - ${hit.variant_title}"
            />
          </a>
        </div>
    
        <div class="ais-hit--details">
        <div class="quick-view">
        <button
          class="button quick-add__button--choose"
          data-product-handle="${hit.handle}"
          data-product-url="/products/${hit.handle}"
          onClick="${(e) => {
            e.preventDefault();
            e.stopPropagation();

            if(hit?.variants_count > 1){
              window.location.href=`/products/${hit.handle}`;
            }else{
              window.openQuickView(hit);
            }
     
          }}"
        >
          <span class="add-to-cart-text">
            <span class="svg-wrapper add-to-cart-icon">
              Quick view
            </span>
          </span>
        </button>
      </div>

          <!-- ✅ OFFER BANNER (title ke upar) -->
          ${isOfferBanner
            ? html`
                <div class="brand-img">
                  <img
                    src="https://cdn.shopify.com/s/files/1/0749/3127/3764/files/listing_offer_banner_28d639f5-7fc5-4b27-9ff0-cb696272aadc.png?v=1792400593"
                    class="brand-image"
                    alt="Free Coffee Machine offer"
                    loading="lazy"
                  />
                </div>
              `
            : null}

          <p class="ais-hit--title">
             <a
              data-algolia-index="${hit.index}"
              data-algolia-position="${hit.productPosition}"
              data-algolia-queryid="${hit.queryID}"
              data-algolia-objectid="${hit.objectID}"
              href="/products/${hit.handle}${
                localStorage.getItem('shopbybrand') ? '?shopbybrand' : ''
              }"
              title="${algoliaShopify.helpers.fullTitle(
                hit.title,
                hit._distinct,
                hit.variant_title
              )}"
            >
              ${components.Highlight({ attribute: 'title', hit })}
              ${algoliaShopify.helpers.variantTitleAddition(hit, hit._distinct)}
            </a>
          </p>
          
            ${!hit._distinct &&
              html`
                <span class="ais-hit--price-discount"
                  >${algoliaShopify.helpers.displayDiscount(
                    hit.price,
                    hit.compare_at_price,
                    hit.price_ratio
                  )}</span
                >
              `}
               
${isComingSoon
  ? html`
      <div class="coming-soon">
        <span class="coming-soon-main">Coming Soon</span>
      </div>
    `
  : ''}

          
          
          
      
          <div class="addtocart-price-section">
            ${
              !hit._distinct
                ? (() => {
                    const initialPrices = getPriceSync(hit);
                    const initialPrice = Number(hit.price) || 0;

                    const cartSvg = html`
                      <svg xmlns="http://www.w3.org/2000/svg"
                          width="20" height="20" viewBox="0 0 20 20"
                          fill="none" aria-hidden="true">
                        <g stroke="#4E4E4E" stroke-width="1.66667"
                          stroke-linecap="round" stroke-linejoin="round">
                          <path d="M7.5 18.333a.833.833 0 1 0 0-1.666.833.833 0 0 0 0 1.666Z"/>
                          <path d="M16.667 18.333a.833.833 0 1 0 0-1.666.833.833 0 0 0 0 1.666Z"/>
                          <path d="M.833.833h3.334L6.4 11.992a1.667 1.667 0 0 0 1.667 1.341h8.1a1.667 1.667 0 0 0 1.666-1.341L19.167 5H5"/>
                        </g>
                      </svg>
                    `;

                    const arrowSvg = html`
                      <svg xmlns="http://www.w3.org/2000/svg"
                          width="20" height="20" viewBox="0 0 20 20"
                          fill="none" aria-hidden="true">
                        <path d="M5 15L15 5M6 5H15V14"
                              stroke="currentColor" stroke-width="1.6"
                              stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    `;

                    return html`
                      <p
                        class="ais-hit--price"
                        data-shopify-price
                        data-handle="${hit.handle || ''}"
                        data-variant-id="${hit.objectID}"
                        data-title="${hit.title}"
                        data-code="${hit.sku || ''}"
                        data-supplier="${hit.vendor || ''}"
                        data-img="${algoliaShopify.helpers.largeImage(hit)}"
                        data-availdate="${hit?.meta?.custom?.avail_since || ''}"
                        data-commingsoon="${commingsoon}"
                        data-can-order="${hitCanOrder}"
                        style="${initialPrice <= 0 ? 'display:none;' : ''}"
                      >
                        <b>${initialPrices.price}</b>

                        ${
                          initialPrice > 0 && initialPrices.compare
                            ? html`
                                <span class="ais-hit--price-striked">
                                  <span>${initialPrices.compare}</span>
                                </span>
                              `
                            : ''
                        }
                      </p>

                      <form
                        id="algolia-add-to-cart-${hit.objectID}"
                        style="display:none;"
                        action="/cart/add"
                        method="post"
                        enctype="multipart/form-data"
                      >
                        <input type="hidden" name="id" value="${hit.objectID}" />
                      </form>

                      <p class="ais-hit--cart">
                        ${
                          initialPrice <= 0
                            ? html`
                                <a
                                  href="/products/${hit.handle}"
                                  class="ais-hit--cart-button ais-hit--product-link"
                                  aria-label="View ${hit.title}"
                                >
                                  ${arrowSvg}
                                </a>
                              `
                            : hitCanOrder
                              ? html`
                                  <button
                                    class="ais-hit--cart-button"
                                    data-form-id="algolia-add-to-cart-${hit.objectID}"
                                    data-commingsoon="${commingsoon}"
                                    data-title="${hit.title}"
                                    data-code="${hit.sku || ''}"
                                    data-supplier="${hit.vendor || ''}"
                                    data-img="${algoliaShopify.helpers.largeImage(hit)}"
                                    data-availdate="${hit?.meta?.custom?.avail_since || ''}"
                                    onClick="${(e) => handleAddToCartClick(e, hit)}"
                                    aria-label="Add ${hit.title} to cart"
                                  >
                                    <span class="add-to-cart-text">
                                      <span class="svg-wrapper add-to-cart-icon">
                                        ${cartSvg}
                                      </span>
                                    </span>
                                  </button>
                                `
                              : html`
                                  <button
                                    class="ais-hit--cart-button ais-hit--cart-button__disabled"
                                    disabled
                                    type="button"
                                    aria-label="Unavailable"
                                  >
                                    <span class="add-to-cart-text">
                                      <span class="svg-wrapper add-to-cart-icon">
                                        ${cartSvg}
                                      </span>
                                    </span>
                                  </button>
                                `
                        }
                      </p>
                    `;
                  })()
                : ''
            }
          </div>




          ${(window.Shopify?.currency?.active || 'AUD') !== 'AUD'
            ? html`<span class="ex-gst-note" style="text-align: left; display: flex;">GST EXEMPT</span>`
            : ""}
          <!-- Extra info examples - Remove the display: none to show them -->
          <p class="ais-hit--info" style="display: none">
            ${hit.sku &&
              html`
                <span class="algolia-sku"
                  >${components.Highlight({ attribute: 'sku', hit })}</span
                >
              `}
            ${hit.barcode &&
              html`
                <span class="algolia-barcode"
                  >${components.Highlight({ attribute: 'barcode', hit })}</span
                >
              `}
            ${hit.weight &&
              html`
                <span class="algolia-weight">${hit.weight}</span>
              `}
            ${!hit.taxable &&
              html`
                <span class="algolia-taxable"
                  >${algoliaShopify.translations.taxFree}</span
                >
              `}
          </p>
          <!-- Tags example - Remove the display: none to show them -->
          <p class="ais-hit--tags" style="display: none">
            ${hit?._highlightResult.tags?.map(
              tag =>
                html`
                  <span class="ais-hit--tag">${tag.value}</span>
                `
            )}
          </p>
        </div>       
      </div>
      <a class="ydp-wishlist-icon-ais" href="/products/${hit.handle}"></div>
    `;
  });
  
  algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function(_defaultTemplate, data, html) {
 
    return html`
      <div class="ais-page">
        <h2 class="ais-h2">${algoliaShopify.translations.searchTitle}</h2>
        <div class="ais-input">
          <div class="ais-search-box-container"></div>
          <div class="ais-input-button">
            <div class="ais-clear-input-icon"></div>
          </div>
        </div>
        <div class="ais-facets-button">
        <span class="svg-wrapper">
            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.823 6h-12m10 4h-8m2 4h4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path></svg>
          </span>
          ${algoliaShopify.translations.showFilters}
        </div>
        <div class="ais-facets">
          <div class="ais-clear-refinements-container"></div>
          <div class="ais-current-refined-values-container"></div>
          ${algoliaShopify.config.app_blocks_dynamic_widgets_beta_enabled
            ? html`
                <div class="ais-dynamic-widgets-container"></div>
              `
            : data.facets.map(
                facet =>
                  html`
                    <div
                      class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}"
                    >
                      <input
                        class="ais-dropdown-checkbox"
                        type="checkbox"
                        id="${facet.escapedName}"
                        name="dropdown"
                      />
                      <label
                        for="${facet.escapedName}"
                        class="ais-range-slider--header ais-facet--header ais-header"
                        >${facet.title}</label
                      >
                      <div
                        class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"
                      ></div>
                    </div>
                  `
              )}
        </div>
        <div class="ais-block">
          <div class="ais-search-header">
            <div class="ais-stats-container"></div>
            <div class="ais-change-display">
              <span class="ais-change-display-block ais-change-display-selected"
                ><i class="fa fa-th-large"></i
              ></span>
              <span class="ais-change-display-list"
                ><i class="fa fa-th-list"></i
              ></span>
            </div>
            <div class="ais-sort">
              ${data.multipleSortOrders
                ? html`
                    ${algoliaShopify.translations.sortBy}
                    <span class="ais-sort-orders-container"></span>
                  `
                : html`
                    ${algoliaShopify.translations.sortBy}
                    ${algoliaShopify.translations.relevance}
                  `}
            </div>
          </div>
          <div class="ais-hits-container ais-results-as-block"></div>
        </div>
        <div class="ais-pagination-container"></div>
      </div>
    `;
  });
 

  // display add2cart on search modal(start) 
  /*const algoliaObserver = new MutationObserver(() => {
    const items = document.querySelectorAll(".aa-Item, .aa-ItemContent");
    
    items.forEach(item => {
      if (item.querySelector(".algolia-add-to-cart")) return;

      const priceContainer = item.querySelector(".aa-List .aa-ItemContentPrice");
      if (!priceContainer) return;


      // Create Add-to-Cart button
      const btn = document.createElement("button"); 
      btn.className = "aalgolia-add-to-cart";
      btn.dataset.formId = "algolia-add-to-cart-" + variantId;
      btn.style.marginLeft = "8px";
      btn.style.padding = "4px 8px";
      btn.style.fontSize = "14px";
      btn.style.cursor = "pointer";

      // Set the inner HTML including full SVG
      btn.innerHTML = `
        <span class="add-to-cart-text">
          <span class="svg-wrapper add-to-cart-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <g clip-path="url(#clip0_242_906)">
                <path d="M7.49996 18.3333C7.9602 18.3333 8.33329 17.9602 8.33329 17.5C8.33329 17.0398 7.9602 16.6667 7.49996 16.6667C7.03972 16.6667 6.66663 17.0398 6.66663 17.5C6.66663 17.9602 7.03972 18.3333 7.49996 18.3333Z" stroke="#4E4E4E" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M16.6667 18.3333C17.1269 18.3333 17.5 17.9602 17.5 17.5C17.5 17.0398 17.1269 16.6667 16.6667 16.6667C16.2065 16.6667 15.8334 17.0398 15.8334 17.5C15.8334 17.9602 16.2065 18.3333 16.6667 18.3333Z" stroke="#4E4E4E" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M0.833374 0.833328H4.16671L6.40004 11.9917C6.47624 12.3753 6.68496 12.72 6.98966 12.9652C7.29436 13.2105 7.67562 13.3408 8.06671 13.3333H16.1667C16.5578 13.3408 16.9391 13.2105 17.2438 12.9652C17.5484 12.72 17.7572 12.3753 17.8334 11.9917L19.1667 5H5.00004" stroke="#4E4E4E" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"></path>
              </g>
              <defs>
                <clipPath id="clip0_242_906">
                  <rect width="20" height="20" fill="white"></rect>
                </clipPath>
              </defs>
            </svg>
          </span>
        </span>
      `;

      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        })
        .then(res => res.json())
        .then(data => {
          console.log("CASE 011: Added to cart", data);
        })
        .catch(err => {
          console.error("CASE 011 ERROR:", err);
        });
      });

      priceContainer.appendChild(btn);
    });
  });

  algoliaObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });*/
  // display add2cart on search modal(end) 



async function refreshAlgoliaShopifyPrices() {
  const elements = document.querySelectorAll(
    '[data-shopify-price]:not([data-price-loaded="true"]):not([data-price-loading="true"])'
  );

  await Promise.all(
    Array.from(elements, async element => {
      const handle = element.dataset.handle;
      const variantId = element.dataset.variantId;

      if (!handle || !variantId) return;

      element.dataset.priceLoading = "true";

      try {
        const live = await getShopifyPriceSync({
          handle,
          objectID: variantId
        });

        const format = value =>
          new Intl.NumberFormat(
            document.documentElement.lang || "en-AU",
            {
              style: "currency",
              currency: live.currency
            }
          ).format(value);

        const section = element.closest(".addtocart-price-section");
        const action = section?.querySelector(".ais-hit--cart-button");

        // Add/remove the class based on the live Shopify price.
        if (section) {
          section.classList.toggle(
            "no-price-element",
            Number(live.price) <= 0
          );
        }

        // Shopify price is zero: hide price and show product arrow.
        if (Number(live.price) <= 0) {
          element.style.display = "none";
          element.replaceChildren();

          if (action && action.tagName !== "A") {
            const link = document.createElement("a");

            link.href = `/products/${encodeURIComponent(handle)}`;
            link.className =
              "ais-hit--cart-button ais-hit--product-link";
            link.setAttribute(
              "aria-label",
              `View ${element.dataset.title || "product"}`
            );

            link.innerHTML = `
              <svg xmlns="http://www.w3.org/2000/svg"
                   width="20" height="20" viewBox="0 0 20 20"
                   fill="none" aria-hidden="true">
                <path d="M5 15L15 5M6 5H15V14"
                      stroke="currentColor" stroke-width="1.6"
                      stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            `;

            action.replaceWith(link);
          }

          element.dataset.priceLoaded = "true";
          return;
        }

        // Shopify price is positive: display the latest price.
        element.replaceChildren();

        const price = document.createElement("b");
        price.textContent = format(live.price);
        element.appendChild(price);
        element.style.display = "";

        if (live.compare != null && live.compare > live.price) {
          const wrapper = document.createElement("span");
          wrapper.className = "ais-hit--price-striked";

          const compare = document.createElement("span");
          compare.textContent = format(live.compare);

          wrapper.appendChild(compare);
          element.appendChild(wrapper);
        }

        // If Algolia showed zero but Shopify shows a positive price,
        // replace the arrow with the appropriate cart action.
        if (action && action.tagName === "A") {
          const canOrder = element.dataset.canOrder === "true";

          if (canOrder) {
            const button = document.createElement("button");
            button.type = "button";
            button.className = "ais-hit--cart-button";
            button.setAttribute(
              "data-form-id",
              `algolia-add-to-cart-${variantId}`
            );
            button.setAttribute(
              "data-commingsoon",
              element.dataset.commingsoon || "false"
            );
            button.setAttribute("data-title", element.dataset.title || "");
            button.setAttribute("data-code", element.dataset.code || "");
            button.setAttribute("data-supplier", element.dataset.supplier || "");
            button.setAttribute("data-img", element.dataset.img || "");
            button.setAttribute(
              "data-availdate",
              element.dataset.availdate || ""
            );
            button.setAttribute(
              "aria-label",
              `Add ${element.dataset.title || "product"} to cart`
            );

            button.innerHTML = `
              <span class="add-to-cart-text">
                <span class="svg-wrapper add-to-cart-icon">
                  <svg xmlns="http://www.w3.org/2000/svg"
                       width="20" height="20" viewBox="0 0 20 20"
                       fill="none" aria-hidden="true">
                    <g stroke="#4E4E4E" stroke-width="1.66667"
                       stroke-linecap="round" stroke-linejoin="round">
                      <path d="M7.5 18.333a.833.833 0 1 0 0-1.666.833.833 0 0 0 0 1.666Z"/>
                      <path d="M16.667 18.333a.833.833 0 1 0 0-1.666.833.833 0 0 0 0 1.666Z"/>
                      <path d="M.833.833h3.334L6.4 11.992a1.667 1.667 0 0 0 1.667 1.341h8.1a1.667 1.667 0 0 0 1.666-1.341L19.167 5H5"/>
                    </g>
                  </svg>
                </span>
              </span>
            `;

            button.addEventListener("click", event => {
              window.handleAddToCartClick(event, {
                handle,
                objectID: variantId
              });
            });

            action.replaceWith(button);
          }
        }

        element.dataset.priceLoaded = "true";
      } catch (error) {
        console.error("Unable to refresh Shopify price:", error);
      } finally {
        delete element.dataset.priceLoading;
      }
    })
  );
}
async function refreshAutocompleteLivePrices() {
  const items = document.querySelectorAll(
    '.aa-ProductItem[data-live-handle][data-live-variant-id]:not([data-live-price-loading="true"]):not([data-live-price-loaded="true"])'
  );

  await Promise.all(
    Array.from(items, async itemLink => {
      const handle = itemLink.dataset.liveHandle;
      const variantId = itemLink.dataset.liveVariantId;
      const priceContainer = itemLink.querySelector(".aa-ItemContentPrice");
      const currentPrice = itemLink.querySelector(".aa-ItemContentPriceCurrent");

      if (!handle || !variantId || !priceContainer || !currentPrice) return;

      itemLink.dataset.livePriceLoading = "true";

      try {
        const live = await getShopifyPriceSync({
          handle,
          objectID: variantId
        });

        if (live.price <= 0) {
          priceContainer.style.display = "none";
        } else {
          const format = value =>
            new Intl.NumberFormat(
              document.documentElement.lang || "en-AU",
              {
                style: "currency",
                currency: live.currency
              }
            ).format(value);

          currentPrice.textContent = format(live.price);
          priceContainer.style.display = "";

          let comparePrice = priceContainer.querySelector(
            ".aa-ItemContentPriceCompare"
          );

          if (live.compare != null && live.compare > live.price) {
            if (!comparePrice) {
              comparePrice = document.createElement("div");
              comparePrice.className = "aa-ItemContentPriceCompare";
              comparePrice.style.cssText =
                "text-decoration:line-through;color:#999;font-size:0.85em";
              priceContainer.appendChild(comparePrice);
            }

            comparePrice.textContent = format(live.compare);
          } else if (comparePrice) {
            comparePrice.remove();
          }
        }

        itemLink.dataset.livePriceLoaded = "true";
      } catch (error) {
        console.error("Autocomplete live price update failed:", error);
      } finally {
        delete itemLink.dataset.livePriceLoading;
      }
    })
  );
}
const algoliaPriceObserver = new MutationObserver(() => {
  refreshAlgoliaShopifyPrices();
  refreshAutocompleteLivePrices();
});

algoliaPriceObserver.observe(document.body, {
  childList: true,
  subtree: true
});

refreshAlgoliaShopifyPrices();
refreshAutocompleteLivePrices();
});